import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "finish-business" }
const _hoisted_2 = { class: "finish-business__title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "finish-business__sub-title sub-title" }
const _hoisted_5 = { class: "sub-title__prefix" }
const _hoisted_6 = { class: "sub-title__suffix" }
const _hoisted_7 = { class: "finish-business__radio-button-container radio-button-container" }
const _hoisted_8 = { class: "radio-button-container__default-input" }
const _hoisted_9 = {
  class: "radio-button-container__label",
  for: "radio-button-container__button--default-input"
}
const _hoisted_10 = { class: "radio-button-container__original-input" }
const _hoisted_11 = {
  class: "radio-button-container__label",
  for: "radio-button-container__button--original-input"
}
const _hoisted_12 = { class: "finish-business__linking-container linking-container" }
const _hoisted_13 = { class: "linking-container__at--content" }
const _hoisted_14 = { class: "linking-container__at--label" }
const _hoisted_15 = { class: "linking-container__at--error" }
const _hoisted_16 = { class: "finish-business__button-container" }

import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { RegisterSettingStore } from '../../RegisterSettingStore';
import { storeToRefs } from 'pinia';
import SelectableField from '../SelectableField.vue';
import { computed, ref, watch } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'FinishBusiness',
  props: {
    store: {}
  },
  emits: ["on-click-back"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const { state } = storeToRefs(props.store);
const selectedFieldId = ref<string>('');
const emits = __emit;

const imagesRequire = require.context('@/assets/img', false, /^\.\/register-input-step-flow-3.*\.png$/);
const localedRegisterInputStepFlowImage = ref(imagesRequire('./register-input-step-flow-3.png'));

watch(
  () => i18n.locale,
  (newVal) => {
    localedRegisterInputStepFlowImage.value =
      newVal === 'en' ? imagesRequire('./register-input-step-flow-3__en.png') : imagesRequire('./register-input-step-flow-3.png');
  },
  {
    immediate: true,
  }
);

/**
 * 戻るボタン
 */
const onClickBackButton = () => {
  emits('on-click-back');
};

const selectedFieldSuggestions = computed(() => {
  return state.value.uploadBusiness.businessHeaderCandidate.map((candidate) => candidate.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('取引紐付け：タイトル')), 1),
    _createElementVNode("img", {
      src: localedRegisterInputStepFlowImage.value,
      class: "finish-business__progress"
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('取引紐付け：本文')), 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('取引紐付け：注釈')), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          id: "radio-button-container__button--default-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).linkingBusiness.useLinkingType) = $event)),
          class: "radio-button-container__button",
          type: "radio",
          value: "Default"
        }, null, 512), [
          [_vModelRadio, _unref(state).linkingBusiness.useLinkingType]
        ]),
        _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('取引紐付け：ラジオボタン：デフォルト書式')), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          id: "radio-button-container__button--original-input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).linkingBusiness.useLinkingType) = $event)),
          class: "radio-button-container__button",
          type: "radio",
          value: "Original"
        }, null, 512), [
          [_vModelRadio, _unref(state).linkingBusiness.useLinkingType]
        ]),
        _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)('取引紐付け：ラジオボタン：オリジナル書式')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).linkingBusiness.linkedBusinessHeaders, (header) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `finish-business-header-${header.key}`,
          class: "linking-container__at"
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)(header.displayName) + (header.required ? '*' : '')), 1),
            _createVNode(SelectableField, {
              value: header.value,
              "selected-id": selectedFieldId.value,
              hint: _unref(t)('取引紐付け：サジェストヒント'),
              suggestions: selectedFieldSuggestions.value
            }, null, 8, ["value", "selected-id", "hint", "suggestions"])
          ]),
          _createElementVNode("span", _hoisted_15, _toDisplayString(header.validateError == 'NotSelected' ? _unref(t)('取引紐付け：アラート文言：必須項目') : '　'), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(TextButton, {
        "button-style": 'btn-secondary',
        size: 'btn-md',
        "on-click": onClickBackButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：戻るボタン')), 1)
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})